// actions
export const LOAD_BOTTLES = 'LOAD_BOTTLES'
// commit
export const SET_BOTTLES = 'SET_BOTTLES'
